export default __webpack_public_path__ + "static/media/package.6c922a30.svg";